module.exports = __webpack_public_path__ + "images/email/avatar-70-01e173616e2ef760a167970ea435e695.png";